import './List.less';
import * as React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { showAlertHOC, List } from 'components';
import DotDotDot from '@mpc/common/src/components/DotDotDot';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { searchToQuery } from 'utils/router';
import * as actions from 'modules/actions/workbench';
import listHOC from './listHOC';
import { Button } from '@beehive/components';
import messages from 'messages/Workbench/List';
import element from 'utils/element';

export interface WorkbenchListProps {
  menuKey: string;
  getColumns?: any;
}

class WorkbenchList extends React.Component<WorkbenchListProps, any> {
  public static contextTypes = {
    intl: PropTypes.object,
  };
  public render() {
    return <List {...this.props} className="workbench-list" />;
  }
}

const mapState2Props = (state: any, ownProps: any) => {
  const { menuKey } = ownProps;
  const data = ownProps.data || state.workbench[_.snakeCase(menuKey)];
  return {
    data,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<actions.WorkbenchActions>, ownProps: any) => {
  return bindActionCreators(
    {
      getList: ownProps.getList || actions.getList,
      getFilterOptions: ownProps.getFilterOptions || actions.getFilterOptions,
      changeConditions: ownProps.changeConditions || actions.changeConditions,
      changeCheck: ownProps.changeCheck || actions.changeCheck,
    },
    dispatch,
  );
};

const getDefaultColumns = (intl: any, ownProps: any) => {
  const { readOnly = true } = ownProps;

  return {
    checkbox: {
      width: 64,
      fixed: 'left',
    },
    id: {
      align: 'left',
      width: 120,
      render: (v: any, r: any, i: number) => {
        return (
          <Button href={`/#/smWorkbench/projectDetailSingle/${v}`} target="_blank">
            {v}
          </Button>
        );
      },
    },
    name: {
      align: 'left',
      width: 300,
    },
    product_identifier: {
      align: 'left',
      width: 120,
    },
    principal_names: {
      align: 'left',
      width: 180,
      render: (v: any, r: any, i: number) => {
        return <DotDotDot clamp={2}>{v}</DotDotDot>;
      },
    },
    expect_begin_at: {
      align: 'left',
      width: 128,
    },
    expect_end_at: {
      align: 'left',
      width: 128,
    },
    planner_names: {
      align: 'left',
      width: 180,
      render: (v: any, r: any, i: number) => {
        return <DotDotDot clamp={2}>{v}</DotDotDot>;
      },
    },
    plan_type: {
      align: 'left',
      width: 200,
    },
    supplier_quote_price: {
      align: 'left',
      width: 180,
    },
    settle_price: {
      align: 'left',
      width: 180,
    },
    translated_purchasing_method: {
      // 采购方式,翻译全名
      width: 180,
      align: 'left',
    },
    formatted_quote_deadline: {
      align: 'left',
      width: 300,
      render: (v: any, r: any, i: number) => {
        const diffHours = moment(v).diff(moment().startOf('days'), 'hours');
        let info = '';
        let className = '';
        if (diffHours < 0) {
          info = intl.formatMessage(messages.dateAfter);
          className = 'date-info data-after';
        } else if (diffHours >= 0 && diffHours < 24) {
          info = intl.formatMessage(messages.dateNow);
          className = 'date-info date-now';
        } else if (diffHours >= 24) {
          const diffDays = _.round(diffHours / 24, 0);
          if (diffDays <= 3) {
            info = intl.formatMessage(messages.dateBefore, { diff: diffDays });
            className = 'date-info data-before';
          }
        }
        return (
          <span>
            {v}
            <span className={className}>{info}</span>
          </span>
        );
      },
    },
    operation: {
      width: 100,
      align: 'left',
      fixed: 'right',
      render: (v: any, r: any, i: number) => {
        if (readOnly) {
          return;
        }

        return r['can_move_wb?'] ? (
          <Button link>{intl.formatMessage(messages.handle)}</Button>
        ) : null;
      },
    },
  };
};

export const tableOptions = (ownProps: any) => {
  const { history, location, getColumns, menuKey, intl } = ownProps;
  const ownColumns = (getColumns && getColumns()) || {};
  const projectId = +String(searchToQuery(location).projectId);
  return {
    expandableColumn: 'name',
    defaultExpandAllRows: true,
    getColumns: () => {
      return _.merge(
        {
          id: {},
        },
        getDefaultColumns(intl, ownProps),
        ownColumns,
      );
    },
    onRow: (r: any, i: number) => {
      return {
        onClick: (event: any) => {
          const clickEle = event.target;
          const isFinishCol = element.closest(
            event.target as HTMLElement,
            '.mpc-table-col-finished',
          );

          if (
            r.children ||
            (window &&
              window.getSelection &&
              // @ts-ignore
              window.getSelection().type === 'Range') ||
            (clickEle &&
              (clickEle.tagName === 'A' ||
                clickEle.classList.contains('beehive-checkbox-input'))) ||
            isFinishCol
          ) {
            return;
          }

          // TODO: 如果是招采流程
          if (r.purchasing_type === 'pending_bidding') {
            window.open(`/#/bidding/toDoProcess?projectId=${r.bidding_id}`, '_blank');
            return;
          }

          if (location && projectId !== r.id) {
            history.push({
              ...location,
              search: `?projectId=${r.id}`,
            });
          }
        },
      };
    },
    rowClassName: (r: any, i: number) => {
      return classNames({
        selected: r.id === projectId,
        'can-click': !r.children || !r.children.length,
        disabled: r.finished,
      });
    },
  };
};

export default connect(
  mapState2Props,
  mapDispatchToProps,
)(showAlertHOC(listHOC(tableOptions)(WorkbenchList)));
